import { render, staticRenderFns } from "./MaterialCompany.vue?vue&type=template&id=9b5503a6&scoped=true&"
import script from "./MaterialCompany.vue?vue&type=script&lang=js&"
export * from "./MaterialCompany.vue?vue&type=script&lang=js&"
import style0 from "./MaterialCompany.vue?vue&type=style&index=0&id=9b5503a6&lang=less&scoped=true&"
import style1 from "./MaterialCompany.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b5503a6",
  null
  
)

export default component.exports